<template>
  <a-modal
    title="操作"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :maskClosable="false"
    :footer="false"
  >
    <div class="table-page-search-wrapper">
      <a-form-item style="display: none">
        <a-input v-decorator="['id']" />
      </a-form-item>

      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <label class="threela">补价信息:</label>
          <a-row :gutter="7">
            <a-col :span="9">
              <a-form-item label="企业名称">
                <a-input v-model="markup.enterpriseName" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="企业申请价格">
                <a-input v-model="markup.enterprisePrice" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="师傅申请价格">
                <a-input v-model="markup.price"  disabled="disabled"/>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="补价类型">
                <a-input v-model="markup.types" disabled="disabled" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="申请时间">
                <a-input v-model="markup.createTime" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>

          <div style="margin-top: 40px">
            <label class="threela">图&nbsp;&nbsp;&nbsp;&nbsp;片:</label>
            <div style="display: flex; flex-wrap: wrap; margin-left: 6%">
              <div
                v-for="type in fileListMaster"
                style="width: 200px; height: 200px; border: 1px solid #ccc; margin: 10px; text-align: center"
              >
                <a :href="process + '/dfs/download?fileName=' + type.url + '&token=' + headers.token" download>
                  <img
                    style="max-width: 100%; max-height: 100%"
                    :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + type.url"
                  />
                </a>
              </div>
            </div>
          </div>

          <div style="margin-top: 40px">
            <label class="threela">师傅信息:</label>
            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="11">
                <a-form-item label="师傅姓名">
                  <a-input v-model="markup.workName" disabled="disabled" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="师傅电话">
                  <a-input v-model="markup.workPhone" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="22">
                <a-form-item label="师傅地址">
                  <a-input v-model="markup.masterAdress" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div style="margin-top: 40px">
            <label class="threela">客户信息:</label>
            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="11">
                <a-form-item label="客户姓名">
                  <a-input v-model="markup.clientName" disabled="disabled" />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="客户电话">
                  <a-input v-model="markup.clientPhone" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="7" style="margin-top: 10px">
              <a-col :span="22">
                <a-form-item label="客户地址">
                  <a-input v-model="markup.clientAddress" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div style="margin-top: 40px">
            <a-row :gutter="16" style="margin-bottom: 60px">
              <a-col :span="22">
                <a-form-item label="反馈信息" style="width: 100%; margin-bottom: 20px">
                  <a-textarea v-model="markup.feeback" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 34%">
            <a-button type="primary" style="margin-right: 20px; width: 120px" html-type="submit" @click="okBtn"
              >通过</a-button
            >
            <a-button style="width: 120px" @click="ordercancel">不通过</a-button>
          </a-form-item>

          <div></div>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { getPcSupplementInfo, markupOrderPrice } from '@/api/order/increaseAuditList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
export default {
  name: 'increaseAuditModel',
  props: {},
  components: {},
  data() {
    return {
      process: process.env.VUE_APP_API_BASE_URL,
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      fileListMaster: [],
      clientInfoPics: [],
      data: '',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      markup: {},
    }
  },
  beforeCreate() {},
  created() {},
  methods: {
    edit(id) {
      this.fileListMaster = []
      getPcSupplementInfo(id).then((res) => {
        if (res.code === 0) {
          if (null != res.data.imgUrl) {
            let arr = res.data.imgUrl.split(',')
            for (var key of arr) {
              this.fileListMaster.push({
                url: key,
              })
            }
          }
          this.markup = res.data
          this.visible = true

          this.$emit('ok')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    ordercancel() {
      this.markup.state = 2
      if(this.markup.feeback == undefined || this.markup.feeback ==null || this.markup.feeback==''){
        this.$message.error("不通过必须填写反馈信息")
        return
      }
      markupOrderPrice(this.markup).then((res) => {
        if (res.code === 0) {
          this.$message.success('提交成功!')
          this.visible = false
          this.$emit('ok')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    okBtn () {
      if (this.markup.enterprisePrice||this.markup.enterprisePrice===0) {
        this.markup.state = 1
        markupOrderPrice(this.markup).then((res) => {
          if (res.code === 0) {
            this.$message.success('提交成功!')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请填写企业申请价格!')
      }
    },

    handleSubmit (e) {
      this.visible = false
    }
  },

  watch: {}
}
</script>
<style scoped>
.disEvents {
  pointer-events: none;
}
</style>
